import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { BaseUI } from '../../base.ui';
import {
    ClientSignatureType,
    OrderClientInterface,
    OrderClientRelation,
    OrderClientStatus,
    OrderDocumentInterface,
    OrderType,
    SelectedProductInterface,
    SelectedProductStatus,
} from '../../../../core';
import { ConfirmDialog } from '../../dialog/confirm/confirm.dialog';
import { Id } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { validateFilesize } from '../../../validators/filesize/validator';
import { validateFiletype } from '../../../validators/filetype/validator';
import { LocalStorage } from '../../../client/helpers/local-storage';

@Component({
    selector: 'thr-order-card',
    templateUrl: './order-card.component.html',
    styleUrls: ['./order-card.component.scss'],
})
export class OrderCardComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ClientSignatureType: typeof ClientSignatureType = ClientSignatureType;
    public OrderClientRelation: typeof OrderClientRelation = OrderClientRelation;
    public OrderClientStatus: typeof OrderClientStatus = OrderClientStatus;
    public OrderType: typeof OrderType = OrderType;
    public SelectedProductStatus: typeof SelectedProductStatus = SelectedProductStatus;

    public documentError: string = null;

    @Input()
    product: SelectedProductInterface;

    @Input()
    documents: OrderDocumentInterface[] = [];

    @Input()
    canSign = false;

    @Input()
    canEdit = false;

    @Input()
    canDelete = false;

    @Input()
    canOperate = false;

    @Output()
    detail: EventEmitter<Id> = new EventEmitter();

    @Output()
    edit: EventEmitter<Id> = new EventEmitter();

    @Output()
    cancelPeriod: EventEmitter<Id> = new EventEmitter();

    @Output()
    download: EventEmitter<Id> = new EventEmitter();

    @Output()
    upload: EventEmitter<File[]> = new EventEmitter();

    @Output()
    validate: EventEmitter<Id> = new EventEmitter();

    @Output()
    sign: EventEmitter<OrderClientInterface> = new EventEmitter();

    @Output()
    remember: EventEmitter<OrderClientInterface> = new EventEmitter();

    @Output()
    viewDocument: EventEmitter<OrderDocumentInterface> = new EventEmitter();

    @Output()
    removeDocument: EventEmitter<OrderDocumentInterface> = new EventEmitter();

    @ViewChild('signedDocument')
    signedDocument: ElementRef;

    constructor(parentEvents: ParentEvents, public dialog: MatDialog, private translator: TranslateService, private localStorage: LocalStorage,
        ) {
        super(parentEvents);
    }

    onSign(client: OrderClientInterface) {
        this.sign.emit(client);
    }

    onRemember(client: OrderClientInterface) {
        this.remember.emit(client);
    }

    onDetail() {
        this.detail.emit(this.product.id as Id);
    }

    onEdit() {
        this.edit.emit(this.product.id as Id);
    }

    onCancelPeriod() {
        this.cancelPeriod.emit(this.product.id as Id);
    }

    onDownload() {
        this.download.emit(this.product.id as Id);
    }

    onUpload() {
        if (this.signedDocument) {
            this.signedDocument.nativeElement.value = null;
            this.signedDocument.nativeElement.click();
        }
    }

    onFileChange(event: Event) {
        this.documentError = null;

        if (event.target instanceof HTMLInputElement) {
            let validateOk = true;

            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files.item(i);

                if (!validateFilesize(file, 100 * 1024 * 1024)) {
                    this.translator.get('form.validation.filesize', { size: 100 }).subscribe((msg) => (this.documentError = msg));
                    validateOk = false;
                } else if (!validateFiletype(file, ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'])) {
                    this.translator.get('form.validation.filetype').subscribe((msg) => (this.documentError = msg));
                    validateOk = false;
                }
                if (!validateOk) {
                    break;
                }
            }

            if (validateOk) {
                this.upload.emit(Array.from(event.target.files));
            }
        }
    }

    onValidate() {
        const dialogRef = this.dialog.open(ConfirmDialog, {
            data: {
                text: 'dialog.confirm-finish-signature',
                ok: 'general.continue',
                cancel: 'general.cancel',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.validate.emit(this.product.id as Id);
            }
        });
    }

    onDocumentView(document: OrderDocumentInterface) {
        if (document.id) {
            this.viewDocument.next(document);
        }
    }

    onDocumentRemove(document: OrderDocumentInterface) {
        if (document.id) {
            document.remove = true;
            this.removeDocument.next(document);
        }
    }
    isValidator(){
        if(this.localStorage.rolName === "Validador"){
            return true;
        }
        else{
            return false;
        }
    }
}
